import { all, call } from 'redux-saga/effects';

import { watchGenerateRotpToken } from '../../common/sagas/startPageSaga';

export const rootSaga = function* rootSaga() {
  yield all({
    watchGenerateRotpToken: call(watchGenerateRotpToken)
  });
};
